import { PcrPayScale } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'
import { PcrPayScaleInput } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPcrPayScale(data: PcrPayScaleInput) {
  return restApiClient
    .url(constructApiUrl(API.pcrPayScale.create.url, null))
    .post<PcrPayScale, PcrPayScaleInput>(data)
}
